<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
        <a
          href="http://www.100ec.cn/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E5%81%A5%E5%BA%B7&category=%E5%85%A8%E9%83%A8"
          target="_blank"
          >更多</a
        >
      </div>

      <Company />
    </div>

    <!-- <div class="right-box">
      <div class="right-title">
        <span>网经社法律消保台</span>
        <a href="http://www.100ec.cn/rulelaw/#/broadcast" target="_blank"
          >更多</a
        >
      </div>
      <div style="width: 300px">
        <a href="http://www.100ec.cn/rulelaw/#/broadcast" target="_blank">
          <img
            style="width: 100%"
            src="/Public/home/images/zyttk/flxb550.jpg"
          />
        </a>
      </div>
    </div> -->

    <Email />
    <!-- <div style="width: 365px">
      <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
        <img style="width: 100%" src="/Public/home/images/zyttk/xfpjr.jpg" />
      </a>
    </div> -->
    <div style="width: 365px; margin-top: 20px">
      <a>
        <img
          style="width: 100%"
          src="/Public/tuku/69e8886adc107.jpg"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "数字健康",
        tabs: [
          "综合类",
          "健康管理",
          "母婴医疗",
          "在线问诊",
          "医药电商",
          "互联网心理",
          "运动健身",
          "疫苗接种",
          "在线挂号",
          "互联网医院",
        ],
      },
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
};
</script>